// extracted by mini-css-extract-plugin
export default {"parametersWrapper":"style_parametersWrapper__iWzvC"};